/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


/* =============================================================================
   A11Y — Sottomenu header
   -----------------------------------------------------------------------------
   Il custom element <hover-disclosure> del tema apre il dropdown solo su
   'mouseenter' e su 'focus' del link di primo livello. In modalita' browse/virtual
   (NVDA, JAWS, VoiceOver) il cursore dello screen reader si muove SENZA spostare
   il focus DOM: l'evento 'focus' non parte mai e il sottomenu non si apre.
   Inoltre non esiste nessun handler di 'click' o 'keydown', quindi Invio non fa
   nulla. -> WCAG 2.1.1 (Keyboard) e 4.1.2 (Name, Role, Value).

   Questa patch, in abbinata a snippets/nav-item.liquid modificato:
     - toglie role/aria-* dall'host <hover-disclosure> (non focusabile e contenente
       l'intero dropdown: il nome accessibile era l'elenco completo del sottomenu);
     - porta aria-expanded/aria-controls sul <button> della voce di menu;
     - aggiunge apertura/chiusura da tastiera (Invio, Spazio, Esc);
     - NEUTRALIZZA l'apertura su 'focus' del tema (vedi sotto);
     - marca il pannello chiuso come `inert`, che copre anche i 200ms di
       transizione in cui il CSS tiene ancora `visibility: visible`.

   PERCHE' DISATTIVARE L'APERTURA SU FOCUS
   Ora che la voce di menu e' un <button>, il click su mouse produce sempre la
   sequenza focus -> click. Se 'focus' aprisse il pannello, il click successivo lo
   troverebbe gia' aperto e lo richiuderebbe subito: il menu non si aprirebbe mai
   col mouse. Il pattern APG Disclosure Navigation prescrive comunque che il focus
   NON apra il pannello: si apre con Invio o Spazio.

   RICHIEDE le modifiche a theme.css indicate in chat: finche' le regole `:hover`
   restano attive, lo stato visivo e lo stato ARIA possono divergere.

   Progressive enhancement: non modifica theme.js. Se questo file non parte,
   il comportamento resta quello originale del tema.
   ========================================================================== */

(function () {
  'use strict';

  var SEL = {
    host: 'hover-disclosure',
    toggle: '[data-submenu-toggle]',
    panel: '.header__dropdown'
  };

  var CLASS_VISIBLE = 'is-visible';

  /* --- Sincronizza lo stato ARIA sul button e inert sul pannello ------------ */
  function syncState(host, isOpen) {
    /* Questi non devono MAI stare sull'host: contiene tutto il dropdown, quindi
       con un role il nome accessibile diventerebbe l'intero elenco del sottomenu.
       ATTENZIONE: aria-controls sull'host NON va rimosso. Il costruttore del tema
       lo usa come chiave per trovare il pannello:
           this.key = this.getAttribute('aria-controls')
           this.disclosure = document.getElementById(this.key)
       Toglierlo manda showDisclosure() in TypeError e il menu non si apre piu'.
       Su un elemento senza role, aria-controls e' ignorato dagli screen reader. */
    host.removeAttribute('role');
    host.removeAttribute('aria-haspopup');
    host.removeAttribute('aria-expanded');

    var toggle = host.querySelector(SEL.toggle);
    var panel = host.querySelector(SEL.panel);

    if (toggle) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (panel) {
      if (isOpen) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    }
  }

  /* --- Patch del prototipo ------------------------------------------------- */
  function patchPrototype() {
    if (!window.customElements) return;

    var Ctor = customElements.get('hover-disclosure');
    if (!Ctor || Ctor.__a11yPatched) return;
    Ctor.__a11yPatched = true;

    var originalShow = Ctor.prototype.showDisclosure;
    var originalHide = Ctor.prototype.hideDisclosure;

    Ctor.prototype.showDisclosure = function (event) {
      // Il solo focus non apre piu' il pannello: serve Invio, Spazio o click.
      if (event && event.type === 'focus') return;

      originalShow.call(this, event);
      syncState(this, true);
    };

    Ctor.prototype.hideDisclosure = function () {
      originalHide.call(this);
      syncState(this, false);
    };
  }

  /* --- Comportamento sul singolo item -------------------------------------- */
  function setup(host) {
    if (host.__a11yBound) return;

    var toggle = host.querySelector(SEL.toggle);
    var panel = host.querySelector(SEL.panel);
    if (!toggle || !panel) return;

    host.__a11yBound = true;

    /* Rete di sicurezza: se per qualsiasi motivo l'host non ha risolto il
       pannello in fase di costruzione (aria-controls assente o aggiunto dopo),
       lo ricolleghiamo qui, cosi' show/hide del tema non falliscono. */
    if (!host.disclosure) {
      host.disclosure = panel;
      host.key = panel.id;
    }

    var open = function () {
      host.dispatchEvent(new CustomEvent('theme:disclosure:show'));
    };
    var close = function () {
      host.dispatchEvent(new CustomEvent('theme:disclosure:hide'));
    };
    var isOpen = function () {
      return toggle.getAttribute('aria-expanded') === 'true';
    };

    // Stato iniziale coerente con quello che il tema ha gia' applicato.
    syncState(host, host.classList.contains(CLASS_VISIBLE));

    /* handleTablets() del tema apre il pannello su 'touchstart' a livello di
       host. Senza questa guardia, su tablet il tap sulla voce aprirebbe
       (touchstart) e richiuderebbe subito (click). Il listener sul button e' in
       fase target, quindi legge lo stato PRIMA che l'host lo cambi. */
    var openedByTouch = false;

    toggle.addEventListener(
      'touchstart',
      function () {
        openedByTouch = !isOpen();
      },
      {passive: true}
    );

    // Click = mouse, tap, Invio e Spazio su un <button> nativo, piu'
    // l'attivazione inviata dagli screen reader in modalita' browse.
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (openedByTouch) {
        openedByTouch = false;
        return;
      }

      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    // Esc chiude e riporta il focus sul button che ha aperto il pannello.
    host.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (!isOpen()) return;
      event.stopPropagation();
      close();
      toggle.focus();
    });
  }

  function init() {
    patchPrototype();
    Array.prototype.forEach.call(document.querySelectorAll(SEL.host), setup);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('hover-disclosure').then(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Il theme editor ricarica le sezioni senza ricaricare la pagina.
  document.addEventListener('shopify:section:load', init);
})();
